import {Injectable} from '@angular/core';
import {AngularFireDatabase} from '@angular/fire/database';
import {AngularFireAuth} from '@angular/fire/auth';
import {AngularFireMessaging} from '@angular/fire/messaging';
import {take} from 'rxjs/operators';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {RequestsService} from './requests.service';
import {HttpParams} from '@angular/common/http';

@Injectable()
export class MessagingService {

  currentMessage = new BehaviorSubject(null);
  orderMessage = new BehaviorSubject(null);

  constructor(
    private requestService: RequestsService,
    private angularFireDB: AngularFireDatabase,
    private angularFireAuth: AngularFireAuth,
    private angularFireMessaging: AngularFireMessaging) {
    this.angularFireMessaging.messaging.subscribe(
      (_messaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      }
    );
  }

  /**
   * update token in firebase database
   *
   * @param userId userId as a key
   * @param token token as a value
   */
  updateToken(userId, token) {
    // we can change this function to request our backend service
    this.angularFireAuth.authState.pipe(take(1)).subscribe(
      () => {
        const data = {};
        data[userId] = token;
        this.angularFireDB.object('fcmTokens/').update(data);
      });
  }

  /**
   * request permission for notification from firebase cloud messaging
   *
   * @param userId userId
   */
  requestPermission(userId, storeId) {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        // console.log('token', token);
        this.saveWebToken(userId, storeId, token);
        // this.updateToken(userId, token);
      },
      (err) => {
        console.log('error here');
        console.error('Unable to get permission to notify.', err);
      }
    );
  }

  saveWebToken(userId, storeId, token) {
    let param = new HttpParams()
      .set('token', token)
      .set('user_id', userId)
      .set('store_id', storeId);
    this.requestService.postRequest('settings/save_web_token', param).subscribe(
      (response) => {
        // console.log('save web token response->', response);
      }
    );
  }

  /**
   * hook method when new notification received in foreground
   */
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload) => {
        this.currentMessage.next(payload);
      });
  }

  private messageSource = new BehaviorSubject('!isDining');
  status = this.messageSource.asObservable();

  changeMessage(message: string) {
    this.messageSource.next(message);
  }

}
